import { render, staticRenderFns } from "./OpzioniOrdiniComandi.vue?vue&type=template&id=8a5e7974"
import script from "./OpzioniOrdiniComandi.vue?vue&type=script&lang=ts"
export * from "./OpzioniOrdiniComandi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a5e7974')) {
      api.createRecord('8a5e7974', component.options)
    } else {
      api.reload('8a5e7974', component.options)
    }
    module.hot.accept("./OpzioniOrdiniComandi.vue?vue&type=template&id=8a5e7974", function () {
      api.rerender('8a5e7974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniOrdiniComandi.vue"
export default component.exports